import R from "ramda";
import { validators } from "@simpleryo/syw-form";
import {
  stepStatusMap,
  cardStatusMap,
  groupStatusMap
} from "../constants/status";

/*
* Verify saved cards reducer handles
* 1. verify all the fields' value in the list
* 2. update the cards' and step's status by field's error
* 3, calculate the save data for the API and update the cardsList
* 4. calculate the state of application submittable
* */

const allItemGotSameStatus = (list, status) =>
  R.compose(R.isEmpty, R.filter(item => item.status !== status))(list);

export default (state, action) => {
  const {
    payload: { savedCardsList }
  } = action;

  const {
    applyId,
    activeStep,
    stepsList,
    steps,
    cards,
    groups,
    fields
  } = state;

  const activeStepName = stepsList[activeStep - 1];

  let nextActiveStepStatus;
  let nextSavedCards = {};
  let nextSavedGroups = {};
  let nextVerifiedFields = {};
  let nextSubmittable;

  R.map(cardName => {
    nextSavedCards = {
      ...nextSavedCards,
      [cardName]: {
        id: cards[cardName].id,
        status: cardStatusMap.COMPLETED
      }
    };
    R.map(group =>
      R.map(groupName => {
        nextSavedGroups = {
          ...nextSavedGroups,
          [groupName]: {
            id: groups[groupName].id,
            status: groups[groupName].status
          }
        };
        if (groups[groupName].status === groupStatusMap.ACTIVE) {
          R.map(fieldName => {
            const { rules, value = "", id } = fields[fieldName];
            const error = validators.validateField(rules, value);
            if (error) {
              nextActiveStepStatus = stepStatusMap.ERROR;
              nextSavedCards = {
                ...nextSavedCards,
                [cardName]: {
                  ...nextSavedCards[cardName],
                  status: cardStatusMap.ERROR
                }
              };
            }
            nextVerifiedFields = {
              ...nextVerifiedFields,
              [fieldName]: {
                id,
                value,
                error
              }
            };
          })(groups[groupName].fieldsList);
        }
      })(group.list)
    )(cards[cardName].groupsList);
  })(savedCardsList);

  nextActiveStepStatus = allItemGotSameStatus(
    nextSavedCards,
    cardStatusMap.COMPLETED
  )
    ? stepStatusMap.COMPLETED
    : stepStatusMap.ERROR;

  if (nextActiveStepStatus !== stepStatusMap.COMPLETED) {
    nextSubmittable = false;
  } else {
    nextSubmittable = R.compose(
      R.isEmpty,
      R.filter(name => steps[name].status !== stepStatusMap.COMPLETED),
      R.filter(name => name !== activeStepName)
    )(stepsList);
  }

  return {
    ...state,
    steps: {
      ...state.steps,
      [activeStepName]: {
        ...state.steps[activeStepName],
        status: nextActiveStepStatus
      }
    },
    cards: R.mergeDeepRight(state.cards, nextSavedCards),
    fields: R.mergeDeepRight(state.fields, nextVerifiedFields),
    save: {
      cardsList: savedCardsList,
      data: {
        applyId,
        step: { id: steps[activeStepName].id, status: nextActiveStepStatus },
        cards: nextSavedCards,
        groups: nextSavedGroups,
        fields: nextVerifiedFields
      }
    },
    submit: {
      ...state.submit,
      isActive: nextSubmittable
    }
  };
};
